import React, { useState } from "react";
import { useTable, useSortBy, useFilters } from 'react-table';
import { ReactTableFilter } from './ReactTableFilter';
import axios from '../../../api/management_api';
import Modal from '../../common/modal/Modal';
import StagingModal from './StagingModal';
import { vendors } from '../../../data/constant';
import ErrorBody from '../../common/error/ErrorBody';
import { getVendor, decodeStaging } from './util';

function ReactDataTable({ rowData }) {

  const [rowId, setRowId] = useState();
  const [modal, setModal] = useState({ title: 'title', data: '' });
  const [info, setInfo] = useState();
  const [error, setError] = useState();
  const [stagingData, setStagingData] = useState();

  const setDetails = (data) => {
    setInfo("");
    setError("");
    setModal({ title: `Details`, data: '' });
    if (data) {
      setInfo(data);
      if(data.fileName.includes('CoaxAddressList_Nuuday')){
        setStagingDataForAI(data.vendorID, data.stagingId, data.uniqueAccessLineId, "coax BSA");
      } else if(data.fileName.includes('FiberAddressList')) {
        setStagingDataForAI(data.vendorID, data.stagingId, data.uniqueAccessLineId, "GPON");
      } else {
        setStagingDataForAI(data.vendorID, data.stagingId, data.uniqueAccessLineId, "");
      }
    } else {
      setError("No data found");
    }
  }

  const setStagingDataForAI = (vendorId, stagingId, uniqueAccessLineId, technology) => {
      const vendor = vendors.find(v => v.value === vendorId) ? vendors.find(v => v.value === vendorId).name : null;
      let url = `/v2/whiteListStaging/fetchStagingData?vendor=${vendor}&technology=${encodeURIComponent(technology)}`;

      if (stagingId != null) {
          url += `&stagingId=${stagingId}`;
      }

      if (uniqueAccessLineId != null) {
        url += `&uniqueAccessLineId=${encodeURIComponent(uniqueAccessLineId)}`;
      }

      axios.get(url)
      .then(response => {
        setStagingData(response.data);
      }).catch(err => setError(err.message))
  }

  const data = React.useMemo(
    () => rowData ? rowData.map(data => {
      let byteToString;
      try {
          byteToString = decodeURIComponent(escape(atob(data.jsonWhiteListObject))).toUpperCase();
      } catch {
          byteToString = decodeURIComponent((data.jsonWhiteListObject)).toUpperCase();
      }
      let jsonData = "";
      try {
        jsonData = JSON.parse(byteToString);
      } catch (err) {
        setError("Invalid json format for trans Id " + data.transactionId);
      }
      let vendor = getVendor(data);
      return {
        createdDate: data.createdTime.split("T")[0],
        networkOwner: vendor,
        details: data,
        transStatus: data.transStatus,
        madId: data.madId
      }
    }) : [],
    [rowData]
  )

  const columns = React.useMemo(
    () => [
      { Header: 'Created Date', Footer: 'Created Date', accessor: 'createdDate' },
      {
        Header: 'Details', Footer: 'Details', accessor: 'details',
        Cell: ({ value }) => <button className="btn btn-sm btn-secondary"
          data-toggle="modal" data-target='#tran-modal'
          onClick={() => setDetails(value)}>
          view
        </button>
      },
      { Header: 'Network owner', Footer: 'Network owner', accessor: 'networkOwner' },
      { Header: 'Trans status', Footer: 'Trans status', accessor: 'transStatus' },
      { Header: 'Mad id', Footer: 'Mad id', accessor: 'madId' }
    ],
    []
  )

  const defaultColumn = React.useMemo(() => {
    return {
      Filter: ReactTableFilter
    }
  }, [])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    rows
  } = useTable(
    {
      columns,
      data,
      defaultColumn
    },
    useFilters,
    useSortBy,
  )


  return (
    <>
      <div style={{ position: 'relative', overflow: 'scroll', textAlign: 'center', maxHeight: "70vh" }}>
        <button id="direct-Search" data-toggle="modal" data-target='#tran-modal' hidden></button>
        <Modal id="tran-modal" title={modal.title}
          res={info ? <StagingModal tData={info} sData={stagingData}/> : ''}
          error={error ? <ErrorBody errorMessage={error} /> : ''} />
        <table {...getTableProps()}
          className="table table-sm table-striped table-bordered">
          <thead className="thead-light">
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th key={column.Header}>
                    <span  {...column.getHeaderProps(column.getSortByToggleProps())}>
                      {column.render('Header')}
                      {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                    </span>
                    <div>{column.canFilter ? column.render('Filter') : null}</div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row)
              return (
                <tr className={rowId === row.id ? 'select-row' : ''} {...row.getRowProps()} onClick={() => setRowId(row.id)}>
                  {row.cells.map(cell => {
                    return (
                      <td
                        {...cell.getCellProps()}
                      >
                        {cell.render('Cell')}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
          <tfoot className="thead-light">
            {footerGroups.map(group => (
              <tr {...group.getFooterGroupProps()}>
                {group.headers.map(column => (
                  <th {...column.getFooterProps()}>{column.render("Footer")}</th>
                ))}
              </tr>
            ))}
          </tfoot>
        </table>
      </div>
    </>
  )
}

export default React.memo(ReactDataTable);